<template>
	<div>
		<!-- 周期选择 -->
		<div style="width: 100%;height: 80px;display: flex;align-items: center;">
			<Button @click="changeType(1);" style="margin-right: 16px;" :type="type == 1 ? 'primary' : 'default'">3天</Button>
			<Button @click="changeType(2);" style="margin-right: 16px;" :type="type == 2 ? 'primary' : 'default'">7天</Button>
			<Button @click="changeType(3);" :type="type == 3 ? 'primary' : 'default'">30天</Button>
		</div>
		
		<!-- 统计图 -->
		<div style="width: 100%;display: flex;">
			<Card style="width:700px">
				<p slot="title">
					用户增量（{{userNum}}）
				</p>
				<div style="width: 700px;height: 350px;" ref="userechart">
	
				</div>
			</Card>
			<Card style="width:700px;margin-left: 16px;">
				<p slot="title">
					支付增量（{{totalFee}}）
				</p>
				<div style="width: 700px;height: 350px;" ref="payechart">
	
				</div>
			</Card>
		</div>
	</div>
</template>
<script>
import {getBillData} from '../../utils/api.js'
import * as echarts from 'echarts';
export default{
	name:'Bill',
	data(){
		return {
			data: [],
			type:1,
			userNum:0,
			totalFee:0,
			userOption:{},
			payOption:{}
		}
	},
	methods:{
		changeType(type){
			if(this.type == type){
				return false;
			}
			
			this.type = type;
			this.getUserDataFun();
		},
		getUserDataFun() {
			getBillData({type:this.type}).then(res=>{
				this.data = res['data'];
				this.userNum = res['user_num'];
				this.totalFee = res['total_fee'];
				
				this.renderEchart();
			})			
		},
		renderEchart() {
			var data = this.data;
			var option1, option2;

			//用户新增
			var userLabel = [];
			var userVal = [];
			var payVal = [];
			data.forEach(function(e) {
				userLabel.push(e.label);
				userVal.push({
					value:e.user_num
				});
				payVal.push({
					value: e.amoun_fee,
					name: e.pay_num
				});
			})
			
			const myChart1 = echarts.init(this.$refs['userechart']);
			 
			option1 = {
				tooltip: {
					trigger: 'item', // 触发类型：坐标轴触发
					formatter: '新增用户：{c}'
				},
				xAxis: {
					name: '日期',
					type: 'category',
					data: userLabel,
					axisLabel:{
						rotate:90
					}
				},
				yAxis: {
					name: '数量',
					type: 'value'
				},
				series: [{
					data: userVal,
					type: 'line'
				}]
			};

			myChart1.setOption(option1);
			
			const myChart2 = echarts.init(this.$refs['payechart']);
			option2 = {
				tooltip: {
					trigger: 'item', // 触发类型：坐标轴触发
					formatter: '金额：{c}</br>数量：{b}'
				},
				xAxis: {
					name: '日期',
					type: 'category',
					data: userLabel
				},
				yAxis: {
					name: '金额',
					type: 'value'
				},
				series: [{
					data: payVal,
					type: 'line'
				}]
			};

			myChart2.setOption(option2);
		}
	},
	mounted(){
		this.getUserDataFun();
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/child/Bill.vue